import { render } from "./Technology.vue?vue&type=template&id=28600748&scoped=true"
import script from "./Technology.vue?vue&type=script&lang=js"
export * from "./Technology.vue?vue&type=script&lang=js"

import "./Technology.vue?vue&type=style&index=0&id=28600748&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28600748"]])

export default __exports__